import React from 'react';
import { inject, observer } from 'mobx-react';

import qs from 'qs';

import { fieldValue } from 'sdc-data-models';

export var EntryLabel = inject('typesStore', 'languagesStore')(observer(function (_ref) {
  var typesStore = _ref.typesStore,
      languagesStore = _ref.languagesStore,
      entry = _ref.entry,
      caption = _ref.caption,
      icon = _ref.icon,
      showLinks = _ref.showLinks;

  if (!entry || !entry.id) return null;
  var field = typesStore.typesByID[entry.typeID].title || 'name';
  var label = typeof caption === 'function' ? caption : function (s) {
    return languagesStore.labelFrom(fieldValue(s, field));
  };

  if (!showLinks) return React.createElement(
    'span',
    { className: 'md-label' },
    label(entry)
  );

  var link = {
    id: entry.id,
    type: entry.typeID
  };
  var query = qs.stringify(link);
  return React.createElement(
    'a',
    { className: 'md-link bordered', href: '#?' + query },
    icon && React.createElement('i', { className: 'fa fa-' + icon }),
    React.createElement(
      'span',
      null,
      label(entry)
    )
  );
}));